import { Box, Grid } from "@mui/material";
import { Fragment } from "react";
import { useTheme } from "@mui/material/styles";
import { Theme } from "@mui/material";

import {
  FooterCopyRightGrid,
  FooterLink,
  FooterMainGrid,
  GridItemFooterLink,
} from "./Footer-Styles";

const Footer = () => {
  const theme: Theme = useTheme();

  return (
    <Fragment>
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <FooterMainGrid
          direction={"row"}
          container
          spacing={{
            xs: 1.5,
            sm: 1.5,
            md: 0,
            lg: 0,
            xl: 0,
          }}
        >
          <Grid
            container
            item
            md={4}
            spacing={1}
            justifyContent="space-between"
            alignItems="center"
          >
            <GridItemFooterLink item xs={12} sm={12} md="auto">
              <FooterLink
                href={theme.custom.links.contactUsLink}
                target="_blank"
                underline="always"
              >
                {theme.custom.text.contactUsText}
              </FooterLink>
            </GridItemFooterLink>
            <GridItemFooterLink item xs={12} sm={12} md="auto">
              <FooterLink
                href={theme.custom.links.companyInformationLink}
                target="_blank"
              >
                {theme.custom.text.companyInformationText}
              </FooterLink>
            </GridItemFooterLink>
            <GridItemFooterLink item xs={12} sm={12} md="auto">
              <FooterLink
                href={theme.custom.links.termsAndConditionsLink}
                target="_blank"
              >
                {theme.custom.text.termsAndConditionsText}
              </FooterLink>
            </GridItemFooterLink>
          </Grid>
          <FooterCopyRightGrid
            container
            item
            md={8}
            justifyContent={{
              md: "center",
              sm: "center",
              xs: "center",
            }}
            alignItems={"flex-end"}
            sx={
              { color: theme.custom.colors.footerTextColor }
            }
            tabIndex={0}
          >
            <Grid item>{theme.custom.text.footerText}</Grid>
          </FooterCopyRightGrid>
        </FooterMainGrid>
      </Box>
    </Fragment>
  );
};

export default Footer;
